/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export enum ApiNotificationCause {
    IdentitySubscribed = 'IDENTITY_SUBSCRIBED',
    IdentityMentioned = 'IDENTITY_MENTIONED',
    DropQuoted = 'DROP_QUOTED',
    DropReplied = 'DROP_REPLIED',
    DropVoted = 'DROP_VOTED',
    DropReacted = 'DROP_REACTED',
    WaveCreated = 'WAVE_CREATED',
    AllDrops = 'ALL_DROPS'
}
